import React from "react";
import AppTheme from "../../../../service/app_config/AppTheme";
import { IconNormal } from "../../../../widget/common/ui/Icon";
import { FollowingListContextImport } from "../../../../provider/notices/following_list/FollowingListContextProvider";

const FollowingListActions = () => {
  const { toggleClickDelete, updateShowSearch } = FollowingListContextImport();

  return (
    <>
      <IconNormal
        name="magnify"
        color={AppTheme.themeFont}
        handleClick={() => updateShowSearch()}
      />
      <IconNormal
        name="edit_follow"
        color={AppTheme.themeFont}
        handleClick={() => toggleClickDelete()}
      />
    </>
  );
};

export default FollowingListActions;
